// import { PlFormComponent } from './loan/pl-form/pl-form.component';
// import { PersonalLoanOffersComponent } from './loan/personal-loan-offers/personal-loan-offers.component';
// import { LoanOfferGenService } from './loan/services/loan-offer-gen.service';
// import { PersonalLoanPageComponent } from './loan/personal-loan-page/personal-loan-page.component';
// import { PersonalLoanPageResolver } from './loan/personal-loan-page/personal-loan-page-resolve';
// import { PersonalLoanMainComponent } from './loan/personal-loan-main/personal-loan-main.component';
import 'hammerjs';

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from 'app/approuting.module';
import { AuthModule } from 'app/auth/auth.module';
import { AuthService } from 'app/auth/auth.service';
import { BaseAppComponent } from 'app/base-app/base-app.component';
import { EmiDataService } from 'app/emi-data.service';
import { EmiFooterComponent } from 'app/shared/emi-footer/emi-footer.component';
import { EmiNavComponent } from 'app/shared/emi-nav/emi-nav.component';
import { EmiBaseInfoService } from 'app/shared/services/emi-base-info.service';
import { EmiBasicResolverService } from 'app/shared/services/emi-basic-resolver.service';
import { SharedModule } from 'app/shared/shared.module';
import { partnersComponent } from './shared/partners/partners.component';

import { ProductsModule } from './products/products.module'; 

import { AboutComponent } from './about/about/about.component';
import { PrivacyPolicyComponent } from './about/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './about/terms-of-use/terms-of-use.component';
import { AppComponent } from './app.component';
import { LoadingComponent } from './loading/loading.component';
import { OwlModule } from "ng2-owl-carousel";
// import { Ng2ScrollableModule } from 'ng2-scrollable';

import { AgmCoreModule } from '@agm/core';
import { WidgetHostService } from "app/shared/widget/widget-host-service";
import { CalculatorsModule } from "app/calculators/calculators-module.module";
import { HttpService } from "app/shared/services/http.service";
import { realEstateSpecificGloballyPageResolver } from "app/Real-Estate-Page/services/property.resolver";
import { RealEstateService } from "app/Real-Estate-Page/services/real-estate.service";
import { CompanyDetailsModule } from "app/company-details/company-details.module";
import { CalculatorService } from "app/calculators/calculator.service";
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';


// import { AgmDirectionModule } from 'agm-direction'; 

@NgModule({
  declarations: [
    AppComponent,
    EmiNavComponent,
    EmiFooterComponent,
    BaseAppComponent,
    LoadingComponent,
    PrivacyPolicyComponent,
    TermsOfUseComponent,
    AboutComponent,
    partnersComponent,
  

   ],
  imports: [
    BrowserModule,
    AngularMultiSelectModule,
    FormsModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyBR4MfFpijsqFL8Pl_gftYg2U3CQycfpnY'
    // }),
    ReactiveFormsModule,
    HttpModule,
    OwlModule,
    NgbModule.forRoot(),
    // AgmDirectionModule,
    // MaterialModule.forRoot(),
    AuthModule,
    SharedModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    AppRoutingModule,
    CalculatorsModule,
    CompanyDetailsModule,
    ProductsModule
    // Ng2ScrollableModule
    // MdProgressBarModule
  ],
  exports:[
  ],
  providers: [
    AuthService,
    EmiBaseInfoService,
    EmiBasicResolverService,
    EmiDataService,
    WidgetHostService,
    HttpService,
    RealEstateService,
    realEstateSpecificGloballyPageResolver,
    CalculatorService,
    // PersonalLoanPageResolver,
    // LoanOfferGenService
    
  ],
  bootstrap: [
    AppComponent,
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts